import { FAST_BUZZER_PHASES, canTransitionFastBuzzer, scoreDeltaForDecision, transitionFastBuzzer } from "./fast-buzzer-machine.js";
import { defineGame } from "./game-definition.js";
export const FAST_BUZZER_DEFAULT_CONFIG = Object.freeze({
    rounds: 10,
    preparationDurationMs: 1_200,
    randomWaitMinMs: 2_000,
    randomWaitMaxMs: 6_000,
    activeWindowMs: 3_000,
    roundResultDurationMs: 4_000,
    firstPlacePoints: 100,
    secondPlacePoints: 70,
    thirdPlacePoints: 50,
    participationPoints: 20,
    falseStartPenalty: -50
});
const actions = ["START", "PREPARATION_COMPLETE", "GO", "BUZZ", "FALSE_START", "ROUND_COMPLETE", "NEXT_ROUND", "FINISH", "PAUSE", "RESUME", "SKIP_ROUND", "END", "PLAY_AGAIN"];
export const FAST_BUZZER_DEFINITION = defineGame({
    key: "FAST_BUZZER",
    metadata: {
        slug: "fast-buzzer",
        name: "Fast Buzzer",
        description: "Reaction Race a round automatici con riflessi, false start, tempi e classifica.",
        icon: "⚡",
        catalogStatus: "available",
        maturity: "stable",
        hostAccess: true,
        minimumPlayers: 1,
        maximumPlayers: 100,
        capabilities: ["realtime", "qr-join", "public-display", "persistent-ranking"]
    },
    initialConfig: FAST_BUZZER_DEFAULT_CONFIG,
    supportedConfiguration: ["rounds", "preparationDurationMs", "randomWaitMinMs", "randomWaitMaxMs", "activeWindowMs", "roundResultDurationMs", "firstPlacePoints", "secondPlacePoints", "thirdPlacePoints", "participationPoints", "falseStartPenalty"],
    configurationProfiles: {
        quick: { configuration: { rounds: 5, preparationDurationMs: 1_000, randomWaitMinMs: 1_500, randomWaitMaxMs: 3_500, activeWindowMs: 2_500, roundResultDurationMs: 2_500 }, estimatedMinutes: 4 },
        standard: { configuration: {}, estimatedMinutes: 7 },
        extended: { configuration: { rounds: 20 }, estimatedMinutes: 13 }
    },
    createInitialState: (config = {}) => ({
        phase: "LOBBY",
        roundNumber: 0,
        totalRounds: config.rounds ?? FAST_BUZZER_DEFAULT_CONFIG.rounds,
        pausedFromPhase: null
    }),
    states: FAST_BUZZER_PHASES,
    actions,
    canTransition: (state, action) => canTransitionFastBuzzer(state.phase, action),
    transition: (state, action) => ({
        ...state,
        phase: transitionFastBuzzer(state.phase, action, state.pausedFromPhase && state.pausedFromPhase !== "LOBBY" && state.pausedFromPhase !== "PAUSED" && state.pausedFromPhase !== "FINISHED" ? { resumePhase: state.pausedFromPhase } : {})
    }),
    scoreDelta: (decision) => scoreDeltaForDecision(decision, FAST_BUZZER_DEFAULT_CONFIG),
    views: { host: "fast-buzzer/host", player: "fast-buzzer/player", display: "fast-buzzer/display" },
    realtime: {
        clientToServer: ["host:start", "host:pause", "host:resume", "host:skip-round", "host:end", "host:play-again", "player:buzz"],
        serverToClient: ["action-result", "action-error", "buzz-result"]
    }
});
//# sourceMappingURL=fast-buzzer-definition.js.map